import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { InspectionVisualDto } from '../dto/inspection-visual.dto';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionVisualService extends IApiBackendRouteService {
  protected urlRoute = `${API_BASE_URL}/inspection/visual`;
  constructor(protected readonly http: HttpClient) {
    super();
  }

  private createUrl(inspectionId: number): string {
    return `${API_BASE_URL}/inspection/${inspectionId}/visual`;
  }

  dataForRegisterRecords(
    inspectionId: number
  ): Observable<InspectionVisualDto['dataForRegisterRecords']['result']> {
    return this.http.get<
      InspectionVisualDto['dataForRegisterRecords']['result']
    >(`${this.urlRoute}/${inspectionId}/for-register`);
  }

  createRecord(
    inspectionId: number,
    body: InspectionVisualDto['createRecord']['body']
  ): Observable<InspectionVisualDto['createRecord']['response']> {
    return this.http.post<InspectionVisualDto['createRecord']['response']>(
      `${this.createUrl(inspectionId)}`,
      body
    );
  }

  finishPartial(
    inspectionId: number,
    body: InspectionVisualDto['finishPartialVisual']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/${inspectionId}/finish`, body);
  }
}
